import React, { useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';
import Header from '../components/header';
import Footer from '../components/footer';
import { Helmet } from 'react-helmet'

export default function Barcode() {
  const [barcode, setBarcode] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith('image')) {
      setError('Please upload an image file.');
      setBarcode(null);
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file);
    await img.decode(); // Ensure image is loaded before decoding

    const reader = new BrowserMultiFormatReader();

    try {
      const result = await reader.decodeFromImageElement(img);
      setBarcode(result.getText());
      setError(null);
    } catch (err) {
      setError('❌ No barcode found in the image.');
      setBarcode(null);
    }
  };

  return (
    <div className="outerQr">
      <Helmet>
        <html lang="en" />
        <title>Free Online Barcode Scanner – Scan Barcodes Instantly</title>
        <meta
          name="description"
          content="Scan any barcode instantly using your device's camera. No app or download required. Free and fast barcode scanning tool by Tooliso."
        />
        <link rel="canonical" href="https://tooliso.com/barcodeScan" />

        <meta property="og:title" content="Free Online Barcode Scanner – Tooliso" />
        <meta
          property="og:description"
          content="Use Tooliso’s barcode scanner to instantly read barcodes using your camera. Quick, secure, and completely free."
        />
        <meta property="og:url" content="https://tooliso.com/barcodeScan" />
        <meta property="og:image" content="https://tooliso.com/images/barcodeScan-og.jpg" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Free Online Barcode Scanner – Tooliso" />
        <meta
          name="twitter:description"
          content="Scan barcodes instantly with Tooliso’s free camera-based scanner. No app needed – fast and secure."
        />
        <meta name="twitter:image" content="https://tooliso.com/images/barcodeScan-twitter.jpg" />
      </Helmet>
      <Header />
      <div className="qrCode">
        <div className="innerQr">
          <h1>Barcode Scanner</h1>
          <p>
            Upload an image containing a barcode to scan and decode it. This tool supports various
            barcode formats. Make sure the barcode is clear and not blurry.
          </p>

          <input type="file" accept="image/*" onChange={handleFileChange} />

          {barcode && <p className="barcode-result">✅ Barcode: {barcode}</p>}
          {error && <p className="barcode-error">{error}</p>}
        </div>
      </div>
      <Footer />
    </div>
  );
}
